import React, {Component} from 'react';
import Axios from 'axios';
import {connect} from "react-redux";
import ChartCard from "./ChartCard";
import getAxiosConfig from '../../utils/axiosConfig';
import messageCodes from '../../utils/messageCodes';
import {showToastForBackend, showToastForFrontend} from '../../actions/toastActions';
import {updateGlobalFromTimeAndToTime} from '../../actions/analyticsDatePickerActions';

class ChartList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            charts: []
        };
        this.addChart = this.addChart.bind(this);
        this.changeProperty = this.changeProperty.bind(this);
        this.changeChartSetting = this.changeChartSetting.bind(this);
        this.changeChartType = this.changeChartType.bind(this);
    }

    addChart() {
        let config = getAxiosConfig();
        config["params"] = {userEmail: localStorage.getItem("user")};
        Axios.post(this.props.properties.chartUrl, "", config)
            .then(chart => {
                if (chart) {
                    this.setState(prevState => ({
                        charts: [...prevState.charts, chart.data]
                    }));
                    this.props.showToastForFrontend(messageCodes.CHART_CREATED);
                }
            })
            .catch(err => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                }
            });
    }

    updateChartSettings(chart) {
        let config = getAxiosConfig();
        config["params"] = {userEmail: localStorage.getItem("user")};
        Axios.put(this.props.properties.chartUrl + "settings/" + chart.id, chart.chartSettings, config)
            .then(chartResponse => {
                if (chartResponse) {
                    this.props.showToastForFrontend(messageCodes.CHART_SAVED);
                }
            })
            .catch(err => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                }
            });
    }

    changeChartSetting(chartId, properties) {
        if (!this.props.isReadOnly) {
            this.setState({
                charts: this.state.charts.map(chart => {
                    if (chart.id === chartId) {
                        properties.map(property => {
                            chart.chartSettings = {...chart.chartSettings, [property]: !chart.chartSettings[property]};
                            return chart;
                        });
                        if (!properties.includes("editorMenuOpen")) {
                            this.updateChartSettings(chart);
                        }
                    }
                    return chart;
                })
            });
        }
    }

    changeProperty(chartId, properties, values) {
        this.setState({
            charts: this.state.charts.map(chart => {
                if (chart.id === chartId) {
                    properties.map((property, index) => {
                        chart = {...chart, [property]: values[index]};
                        if(property === "stacked") {
                            chart.chartSettings = {...chart.chartSettings, "editorMenuOpen": false};
                        }
                        return chart;
                    });
                }
                return chart;
            })
        });
    }

    changeChartType(chartId, property, value) {
        this.setState({
            charts: this.state.charts.map(chart => {
                if (chart.id === chartId) {
                    chart.chartSettings = {...chart.chartSettings, [property]: value};
                    chart.chartSettings = {...chart.chartSettings, "editorMenuOpen": false};
                }
                return chart;
            })
        });
    }

    deleteChart(chartId) {
        let config = getAxiosConfig();
        config["params"] = {userEmail: localStorage.getItem("user")};
        Axios.delete(this.props.properties.chartUrl + chartId, config)
            .then(response => {
                if (response) {
                    this.setState({charts: this.state.charts.filter(chart => chart.id !== chartId)});
                    this.props.showToastForFrontend(messageCodes.CHART_DELETED);
                }
            })
            .catch(err => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                }
            });
    }

    componentDidMount() {
        Axios.get(this.props.properties.chartUrl, getAxiosConfig())
            .then(analyticsPageResponse => {
                this.setState({charts: analyticsPageResponse.data.charts});
                this.props.updateGlobalFromTimeAndToTime(analyticsPageResponse.data.fromTime, analyticsPageResponse.data.toTime, analyticsPageResponse.data.presetDate);
            })
            .catch(err => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                }
            });
    }

    componentDidUpdate(_prevProps) {
        const chartUpdate = this.props.chartUpdate;
        if (_prevProps.chartUpdate.date !== chartUpdate.date) {
            this.addChart();
        }
        if (_prevProps.analyticsDatePicker.globalFromTime !== undefined && _prevProps.analyticsDatePicker.globalToTime !== undefined) {
            const isFromTimeUpdated = _prevProps.analyticsDatePicker.globalFromTime !== this.props.analyticsDatePicker.globalFromTime;
            const isToTimeUpdated = _prevProps.analyticsDatePicker.globalToTime !== this.props.analyticsDatePicker.globalToTime;
            if (isFromTimeUpdated || isToTimeUpdated) {
                this.setState({
                    charts: this.state.charts.map(chart => {
                        if (chart.useGlobal) {
                            chart = {...chart,
                                fromTime: this.props.analyticsDatePicker.globalFromTime,
                                toTime: this.props.analyticsDatePicker.globalToTime,
                                presetDate: this.props.analyticsDatePicker.presetDate
                            };
                        }
                        return chart;
                    })
                });
            }
        }
    }

    render() {
        return (
            <div className="panel-container">
                <div className="row">
                    {this.state.charts.map((chart, index) => (
                        <ChartCard chart={chart}
                                   key={index}
                                   changeChartSetting={(chartId, properties) => this.changeChartSetting(chartId, properties)}
                                   changeProperty={(chartId, properties, values) => this.changeProperty(chartId, properties, values)}
                                   changeChartType={(chartId, property, value) => this.changeChartType(chartId, property, value)}
                                   deleteChart={(chartId) => this.deleteChart(chartId)}
                                   isReadOnly={this.props.isReadOnly}
                        />
                    ))}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
        analyticsDatePicker: state.analyticsDatePicker
    }
}

export default connect(mapStateToProps, {
    showToastForFrontend,
    showToastForBackend,
    updateGlobalFromTimeAndToTime
})(ChartList);